import { ConfigProviderProps } from 'antd/es/config-provider';
import zhCN from 'antd/lib/locale/zh_CN';
import dayjs from 'dayjs';

import 'dayjs/locale/zh-cn';

import { THEME_COLOR } from './appConfig';

dayjs.locale('zh-cn');

/**
 * antd 全局配置
 * https://ant.design/components/config-provider-cn/#API
 */
export const antdConfig: ConfigProviderProps = {
  // 组件大小
  componentSize: 'middle',
  // 语言包配置
  locale: zhCN,
  theme: {
    cssVar: true,
    token: {
      colorPrimary: THEME_COLOR,
      borderRadius: 10,
    },
  },
};
